import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { sortBy as _sortBy, split as _split } from 'lodash-es';
import { Subject } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { TitleService } from '../../services/title.service';
import { StockListService } from '../..//services/stock-list.service';
import { collections } from '../../page-config';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';
import { NgClass, AsyncPipe } from '@angular/common';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { EditStockItemComponent } from '../edit-stock-item/edit-stock-item.component';


@Component({
    selector: 'app-stock-list',
    templateUrl: './stock-list.component.html',
    styleUrls: ['./stock-list.component.scss'],
    imports: [BreadCrumbComponent, FormsModule, NgClass, NgbPagination, EditStockItemComponent, AsyncPipe]
})
export class StockListComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private titleService = inject(TitleService);
  private breadcrumbService = inject(BreadcrumbService);
  stockListService = inject(StockListService);


  collections = {};
  filters = { status: undefined, page: 1, code: '', gallery: 'all-all', collection: 'all', type: 'all', supplier: 'all' };
  imageSearch = '';
  statuses = ['Active', 'Discontinued', 'Needs Work', 'New', 'Pending Review'];
  galleryList = _sortBy(Object.keys(collections));
  suppliers = ['Blackman', 'Ansley', 'TJH', 'n/a'];

  search$ = new Subject<string>();

  constructor() {
    this.collections = collections;
    this.route.queryParams.subscribe(({ status = 'all', page = 1, code = '', collection = 'all', type = 'all', supplier = 'all' }) => {
      this.filters.status = status;
      this.filters.page = page;
      this.filters.code = code;
      this.filters.collection = collection;
      this.filters.type = type;
      this.filters.supplier = supplier;
    });

    this.search$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((searchText: string) => {
        console.log(`this.filters.code = ${this.filters.code}, searchText = ${searchText}`);
        this.filters.code = searchText;
        return this.fetch();
      })
    ).subscribe(response => {
      console.log('in search$ subscribe', response);
    });
  }

  ngOnInit(): void {
    this.render();
  }

  render(): void {
    this.titleService.set('Manage Stock');
    this.breadcrumbService.set('Manage Stock');
    this.fetch();
  }

  onModelChange(value: string): void {
    this.search$.next(value);
  }

  fetch() {
    const { status, collection, type, supplier, page, code } = this.filters;
    const filter = code !== '' ? `code~'${code}'` : '';
    console.log(`stock-list fetch filter: ${JSON.stringify({ status, collection, type, supplier, page, filter })}`);
    return this.stockListService.fetch({ status, collection, type, supplier, page, filter });
  }

  filterGallery(): void {
    const [collection, type] = _split(this.filters.gallery, '-');
    this.filters.type = type;
    this.filters.collection = collection;
    this.fetch();
  }

  filterStatus(status): void {
    this.filters.status = status;
    this.fetch();
  }

  goToPage(page): void {
    this.filters.page = page;
    this.fetch();
  }

  ngOnDestroy(): void {
    if (this.search$) {
      this.search$.unsubscribe();
    }
  }
}
